import ControlsScene from "@Scenes/Main/Controls/ControlsScene";
import * as Scenes from '@Config/scenes';

class RightHandedControlsScene extends ControlsScene
{
    constructor()
    {
        super(Scenes.RIGHT_HANDED_CONTROLS);
    }

    /**
     * Create callback
     * This fires as part of the phaser scene lifecycle
     */
    public create()
    {
        const gameSize = this.getGameSize();
        const buttonYPosition = gameSize.height - 100;

        this.enableInput();

        this.createButton({ name: 'accelerate_button', x: 120, y: buttonYPosition, sprite: 'controls', scale:0.8 });
        this.createButton({ name: 'left_button', x: gameSize.width - 310, y: buttonYPosition, sprite: 'controls', scale:0.8 });
        this.createButton({ name: 'right_button', x: gameSize.width - 120, y: buttonYPosition, sprite: 'controls', scale:0.8 });
    }

}

export default RightHandedControlsScene;